if (process.env.NODE_ENV === "production") {
  module.exports = require("./dist/index.prod.js");
} else {
  module.exports = require("./dist/index.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-switch/index.js
// module id = 932
// module chunks = 0